<dl class="kv" aria-label="Key value list">
  @for (item of content.items; track $index) {
    <div class="kv-row">
      <dt class="kv-label">{{ item.label }}</dt>
      <dd class="kv-value">{{ item.value }}</dd>
    </div>
  }
</dl>

